// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"780":"c6d642c9","828":"dd22066c"}[chunkId] + ".chunk.css";
};